export enum PreferredCommunication {
  SMS = "SMS",
  Phone = "Phone",
  Email = "Email",
  Letter = "Letter",
  Linkedin = "Linkedin"
}
